module.exports = __webpack_public_path__ + "img/send_fail.76151bff.png";